import { CompanyAdminContact } from '@app/models/payroll/company/company-admin-contact';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';

export class NameColumn extends Column {
    title = 'payroll.settings.name';
    property = 'name';
    sortable = false;
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(contact: CompanyAdminContact): string {
        return `${contact.firstName} ${contact.lastName}`;
    }

    getBadgeDisplay(contact: CompanyAdminContact): BadgeDisplay | undefined {
        if (contact.isPrimaryContact) {
            return {
                type: 'success',
                label: 'payroll.settings.primaryContact',
            };
        }
    }

    getRowStyling(): null | { [key: string]: string } {
        return {
            display: 'flex',
            gap: '8px',
        };
    }
}
